export default {
  displayDate (date) {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${month}/${day}/${year}`
  },

  saveDate (date) {
    if (!date) return null

    const [month, day, year] = date.split('/')
    return `${year}-${month}-${day}`
  },

  displayTime (time) {
    if (!time) return null

    let [hours, mins] = time.split(':')
    let post = 'AM'

    if (hours >= 12) { post = 'PM' }
    if (hours > 12) { hours = hours - 12 }
    if (hours === '00') { hours = 12 }

    return `${hours}:${mins} ${post}`
  }
}



// WEBPACK FOOTER //
// ./src/services/Utilities.js